import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const SocialRegistration = () => {
  const navigate = useNavigate();
  const [loadingProvider, setLoadingProvider] = useState(null);

  const handleSocialRegister = async (provider) => {
    setLoadingProvider(provider);

    try {
      // Simulate social authentication
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Mock successful social registration
      const userData = {
        id: Date.now(),
        email: `user@${provider}.com`,
        name: 'Cycling Enthusiast',
        avatar: `https://randomuser.me/api/portraits/men/${Math.floor(Math.random() * 50)}.jpg`,
        provider: provider,
        bikeType: '',
        experienceLevel: '',
        location: '',
        createdAt: new Date()?.toISOString()
      };

      // Store user data and auth token
      localStorage.setItem('authToken', `mock-${provider}-token-` + Date.now());
      localStorage.setItem('userProfile', JSON.stringify(userData));

      // Redirect to dashboard
      navigate('/user-dashboard');
    } catch (error) {
      console.error(`${provider} registration failed:`, error);
    } finally {
      setLoadingProvider(null);
    }
  };

  const socialProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Chrome',
      bgColor: 'bg-white',
      textColor: 'text-gray-700',
      borderColor: 'border-gray-300',
      hoverBg: 'hover:bg-gray-50'
    },
    {
      id: 'facebook',
      name: 'Facebook',
      icon: 'Facebook',
      bgColor: 'bg-blue-600',
      textColor: 'text-white',
      borderColor: 'border-blue-600',
      hoverBg: 'hover:bg-blue-700'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-background text-muted-foreground">
            Or continue with
          </span>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {socialProviders?.map((provider) => (
          <button
            key={provider?.id}
            onClick={() => handleSocialRegister(provider?.id)}
            disabled={loadingProvider !== null}
            className={`
              flex items-center justify-center px-4 py-3 border rounded-md text-sm font-medium transition-all duration-200 interactive-scale
              ${provider?.bgColor} ${provider?.textColor} ${provider?.borderColor} ${provider?.hoverBg}
              disabled:opacity-50 disabled:cursor-not-allowed
              focus:ring-2 focus:ring-ring focus:ring-offset-2
            `}
          >
            {loadingProvider === provider?.id ? (
              <Icon name="Loader2" size={18} className="animate-spin mr-2" />
            ) : (
              <Icon name={provider?.icon} size={18} className="mr-2" />
            )}
            <span>
              {loadingProvider === provider?.id 
                ? 'Connecting...' 
                : `Continue with ${provider?.name}`
              }
            </span>
          </button>
        ))}
      </div>
      <div className="text-center">
        <p className="text-xs text-muted-foreground">
          By signing up, you agree to our{' '}
          <button className="text-accent hover:underline">Terms of Service</button>
          {' '}and{' '}
          <button className="text-accent hover:underline">Privacy Policy</button>
        </p>
      </div>
    </div>
  );
};

export default SocialRegistration;